<section class="p-4 gradient-bg min-h-screen">
  <!-- 🔹 Toolbar: Export & Refresh -->
  

  <!-- //new card here -->
  <p-card styleClass="p-card-shadow" class="dashboardTable">
    <!-- 🔹 Header Section -->
    <div class="flex justify-content-end flex-wrap card-container purple-container">
      <div class="flex align-items-center justify-content-end">
        <button
          (click)="exportExcel()"
          pButton
          pRipple
          label="{{ 'EXPORT' | translate }}"
          icon="pi pi-upload"
          class="p-button-help m-3"
        ></button>
    
        <button
          (click)="loadGeoMappings()"
          pButton
          pRipple
          label="{{ 'REFRESH' | translate }}"
          icon="pi pi-refresh"
          class="p-button-info ml-3"
        ></button>
      </div>
    </div>
    
  
    <!-- 🔹 Table Section -->
    <div>
      <p-table
        #dt
        [value]="geoMappings"
        [rows]="10"
        [paginator]="true"
        [loading]="loading"
        [rowHover]="true"
        [scrollable]="true"
        scrollHeight="700px"
        dataKey="userID"
        responsiveLayout="scroll"
        [globalFilterFields]="[
          'userType',
          'userID',
          'officer_Name',
          'geoName',
          'geoType',
          'action'
        ]"
        currentPageReportTemplate="{{ 'SHOWING' | translate }} {first} {{ 'TO' | translate }} {last} {{ 'OF' | translate }} {totalRecords} {{ 'ENTRIES' | translate }}"
        [showCurrentPageReport]="true"
        styleClass="custom-geo-table"
      >
        <!-- 🔹 Caption -->
        <ng-template pTemplate="caption">
          <div class="flex align-items-center justify-content-between">
            <h5 class="m-0">{{ 'View User Mapping' | translate }}</h5>
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                placeholder="{{ 'SEARCH' | translate }}"
              />
            </span>
          </div>
        </ng-template>
  
        <!-- 🔹 Header -->
        <ng-template pTemplate="header">
          <tr>
            <!-- <th pSortableColumn="S.No">
              S.No
              <p-columnFilter type="text" field="S.No" display="menu"></p-columnFilter>
            </th> -->
  
            <th pSortableColumn="userType">
              {{ 'UserType' | translate }}
              <p-columnFilter type="text" field="userType" display="menu"></p-columnFilter>
              <p-sortIcon field="userType"></p-sortIcon>
            </th>
  
            <th pSortableColumn="userID">
              {{ 'UserID' | translate }}
              <p-columnFilter type="text" field="userID" display="menu"></p-columnFilter>
              <p-sortIcon field="userID"></p-sortIcon>
            </th>
  
            <th pSortableColumn="officer_Name">
              {{ 'Officer Name' | translate }}
              <p-columnFilter type="text" field="officer_Name" display="menu"></p-columnFilter>
              <p-sortIcon field="officer_Name"></p-sortIcon>
            </th>
  
            <th pSortableColumn="mobile">
              {{ 'Mobile' | translate }}
              <p-columnFilter type="text" field="mobile" display="menu"></p-columnFilter>
              <p-sortIcon field="mobile"></p-sortIcon>
            </th>
  
            <!-- <th pSortableColumn="emailID">
              {{ 'EmailID' | translate }}
              <p-columnFilter type="text" field="emailID" display="menu"></p-columnFilter>
              <p-sortIcon field="emailID"></p-sortIcon>
            </th> -->
  
            <th pSortableColumn="geoName">
              {{ 'GeoName' | translate }}
              <p-columnFilter type="text" field="geoName" display="menu"></p-columnFilter>
              <p-sortIcon field="geoName"></p-sortIcon>
            </th>
  
            <th pSortableColumn="geoType">
              {{ 'GeoType' | translate }}
              <p-columnFilter type="text" field="geoType" display="menu"></p-columnFilter>
              <p-sortIcon field="geoType"></p-sortIcon>
            </th>
  
            <th pSortableColumn="assignMappingDate">
              {{ 'AssignDate' | translate }}
              <p-columnFilter type="text" field="assignMappingDate" display="menu"></p-columnFilter>
              <p-sortIcon field="assignMappingDate"></p-sortIcon>
            </th>
  
            <th pSortableColumn="unassignMappingDate">
              {{ 'UnassignDate' | translate }}
              <p-columnFilter type="text" field="unassignMappingDate" display="menu"></p-columnFilter>
              <p-sortIcon field="unassignMappingDate"></p-sortIcon>
            </th>
  
            <th pSortableColumn="action">
              {{ 'ACTION' | translate }}
              <p-columnFilter type="text" field="action" display="menu"></p-columnFilter>
              <p-sortIcon field="action"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
  
        <!-- 🔹 Body -->
        <ng-template pTemplate="body" let-item let-ri="rowIndex">
          <tr
            [ngStyle]="{
              'background-color': getGeoRowColor(item.geoType),
              color: 'black'
            }"
          >
            <!-- <td class="text-center">{{ ri + 1 }}</td> -->
            <td>{{ item.userType }}</td>
            <td>{{ item.userID }}</td>
            <td>{{ item.officer_Name }}</td>
            <td>{{ item.mobile }}</td>
            <!-- <td>{{ item.emailID }}</td> -->
            <td>{{ item.geoName }}</td>
            <td>{{ item.geoType }}</td>
            <td>
              {{ item.assignMappingDate ? (item.assignMappingDate | date: 'short') : '-' }}
            </td>
            <td>
              {{ item.unassignMappingDate ? (item.unassignMappingDate | date: 'short') : '-' }}
            </td>
            <td>{{ item.action || '-' }}</td>
          </tr>
        </ng-template>
  
        <!-- 🔹 Summary -->
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between text-sm">
            <div>
              {{ 'TOTAL_RECORDS' | translate }}:
              <strong>{{ geoMappings?.length || 0 }}</strong>
            </div>
            <div class="flex gap-3">
              <div class="flex align-items-center gap-1">
                <div style="background-color:#ffcccc; width:20px; height:20px; border-radius:5px;"></div>
                District
              </div>
              <div class="flex align-items-center gap-1">
                <div style="background-color:#cce5ff; width:20px; height:20px; border-radius:5px;"></div>
                Block
              </div>
              <div class="flex align-items-center gap-1">
                <div style="background-color:#ccffcc; width:20px; height:20px; border-radius:5px;"></div>
                Village
              </div>
              <div class="flex align-items-center gap-1">
                <div style="background-color:#e6f7ff; width:20px; height:20px; border-radius:5px;"></div>
                Other
              </div>
            </div>
          </div>
        </ng-template>
      </p-table>
    </div>
  </p-card>
  
  <!-- //end new card here -->
  

  <!-- 🌍 User Geo Mapping Table -->
  <!-- <p-card class="shadow-md mt-3">
    <p-table
      #dt
      [value]="geoMappings"
      [rows]="10"
      [paginator]="true"
      [loading]="loading"
      [rowHover]="true"
      dataKey="userID"
      responsiveLayout="scroll"
      [scrollable]="true"
      scrollHeight="700px"
      [globalFilterFields]="[
        'userType',
        'userID',
        'officer_Name',
        'geoName',
        'geoType',
        'action'
      ]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [showCurrentPageReport]="true"
      styleClass="custom-geo-table"
    >
     
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
        
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dt.filterGlobal($any($event.target).value, 'contains')"
              placeholder="Search..."
            />
          </span>
        </div>
      </ng-template>
  
     
      <ng-template pTemplate="header">
        <tr class="bg-gray-100 text-gray-800">
    
          <th pSortableColumn="S.No">
            S.No
            <p-columnFilter type="text" field="S.No" display="menu"></p-columnFilter>
            
          </th>
  
          <th pSortableColumn="userType">
            userType
            <p-columnFilter type="text" field="userID" display="menu"></p-columnFilter>
            <p-sortIcon field="userType"></p-sortIcon>
          </th>
          
          <th pSortableColumn="userID">
            User ID
            <p-columnFilter type="text" field="userID" display="menu"></p-columnFilter>
            <p-sortIcon field="userID"></p-sortIcon>
          </th>
  
          <th pSortableColumn="officer_Name">
            Officer Name
            <p-columnFilter type="text" field="officer_Name" display="menu"></p-columnFilter>
            <p-sortIcon field="officer_Name"></p-sortIcon>
          </th>
  
          <th pSortableColumn="mobile">
            Mobile
            <p-columnFilter type="text" field="mobile" display="menu"></p-columnFilter>
            <p-sortIcon field="mobile"></p-sortIcon>
          </th>
  
          <th pSortableColumn="emailID">
            Email
            <p-columnFilter type="text" field="emailID" display="menu"></p-columnFilter>
            <p-sortIcon field="emailID"></p-sortIcon>
          </th>
  
          <th pSortableColumn="geoName">
            Geo Name
            <p-columnFilter type="text" field="geoName" display="menu"></p-columnFilter>
            <p-sortIcon field="geoName"></p-sortIcon>
          </th>
  
          <th pSortableColumn="geoType">
            Geo Type
            <p-columnFilter type="text" field="geoType" display="menu"></p-columnFilter>
            <p-sortIcon field="geoType"></p-sortIcon>
          </th>
  
          <th pSortableColumn="assignMappingDate">
            Assign Date
            <p-columnFilter type="text" field="assignMappingDate" display="menu"></p-columnFilter>
            <p-sortIcon field="assignMappingDate"></p-sortIcon>
          </th>
  
          <th pSortableColumn="unassignMappingDate">
            Unassign Date
            <p-columnFilter type="text" field="unassignMappingDate" display="menu"></p-columnFilter>
            <p-sortIcon field="unassignMappingDate"></p-sortIcon>
          </th>
  
          <th pSortableColumn="action">
            Action
            <p-columnFilter type="text" field="action" display="menu"></p-columnFilter>
            <p-sortIcon field="action"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="body" let-item let-ri="rowIndex">
        <tr
          [ngStyle]="{
            'background-color': getGeoRowColor(item.geoType),
            color: 'black'
          }"
        >
          <td class="text-center">{{ ri + 1 }}</td>
          <td>{{ item.userType }}</td>
          <td>{{ item.userID }}</td>
          <td>{{ item.officer_Name }}</td>
          <td>{{ item.mobile }}</td>
          <td>{{ item.emailID }}</td>
          <td>{{ item.geoName }}</td>
          <td>{{ item.geoType }}</td>
          <td>
            {{ item.assignMappingDate ? (item.assignMappingDate | date:'short') : '-' }}
          </td>
          <td>
            {{ item.unassignMappingDate ? (item.unassignMappingDate | date:'short') : '-' }}
          </td>
          <td>{{ item.action || '-' }}</td>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between text-sm">
          <div>
            Total Records:
            <strong>{{ geoMappings?.length || 0 }}</strong>
          </div>
          <div class="flex gap-3">
            <div class="flex align-items-center gap-1">
              <div
                style="background-color:#ffcccc; width: 20px; height: 20px; border-radius: 5px;"
              ></div>
              District
            </div>
            <div class="flex align-items-center gap-1">
              <div
                style="background-color:#cce5ff; width: 20px; height: 20px; border-radius: 5px;"
              ></div>
              Block
            </div>
            <div class="flex align-items-center gap-1">
              <div
                style="background-color:#ccffcc; width: 20px; height: 20px; border-radius: 5px;"
              ></div>
              Village
            </div>
            <div class="flex align-items-center gap-1">
              <div
                style="background-color:#e6f7ff; width: 20px; height: 20px; border-radius: 5px;"
              ></div>
              Other
            </div>
          </div>
        </div>
      </ng-template>
    </p-table>
  </p-card>
   -->








<!-- // map start here -->
<!-- 🌍 Geo Mapping Table -->
<!-- <p-table [value]="geoMappings" [paginator]="true" [rows]="10">
  <ng-template pTemplate="header">
    <tr>
      <th>User ID</th>
      <th>Officer Name</th>
      <th>Geo Name</th>
      <th>Geo Type</th>
      <th>Action</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rowData>
    <tr>
      <td>{{ rowData.userID }}</td>
      <td>{{ rowData.officer_Name }}</td>
      <td>{{ rowData.geoName }}</td>
      <td>{{ rowData.geoType }}</td>
      <td>
        <button
          pButton
          label="Show on Map"
          icon="pi pi-map"
          class="p-button-info"
          (click)="openGeoMap(rowData.userID)"
        ></button>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  header="User Geo Map"
  [(visible)]="geoMapDialogVisible"
  [modal]="true"
  [resizable]="true"
  [draggable]="false"
  [style]="{ width: '90vw', height: '80vh' }"
  (onShow)="onMapDialogShow()"
>
  <div style="width: 100%; height: 100%">
    <p-gmap
      #gmap
      [style]="{ width: '100%', height: '100%', 'border-radius': '8px' }"
      [options]="options"
      [overlays]="overlays"
      (onMapClick)="handleMapClick($event)"
      (onOverlayClick)="handleOverlayClick($event)"
      (onOverlayDragEnd)="handleDragEnd($event)"
    >
    </p-gmap>
  </div>
</p-dialog> -->





<!-- // map end here -->





  <!-- 🔹 Spinner Overlay -->
  <div *ngIf="loading" id="pause">
    <div id="spinner"></div>
  </div>
</section>
